export const videoTitleMaxLength = 80
